import React from 'react';
import { Trophy, Medal, Crown } from 'phosphor-react';
import { getAvatarIcon } from './AvatarSelector';

const PodiumPosition = ({ position, player, height }) => {
  const getPositionStyles = () => {
    switch (position) {
      case 1:
        return 'bg-gray-800 border-t-4 border-blue-500 shadow-[0_0_20px_rgba(59,130,246,0.3)]';
      case 2:
        return 'bg-gray-800 border-t-4 border-blue-400 shadow-[0_0_20px_rgba(59,130,246,0.2)]';
      case 3:
        return 'bg-gray-800 border-t-4 border-blue-300 shadow-[0_0_20px_rgba(59,130,246,0.15)]';
      default:
        return 'bg-gray-800 border-t-4 border-gray-700';
    }
  };

  const getMedalTitle = () => {
    switch (position) {
      case 1:
        return 'Pierwsze miejsce';
      case 2:
        return 'Drugie miejsce';
      case 3:
        return 'Trzecie miejsce';
      default:
        return '';
    }
  };

  const getMedalIcon = () => {
    const size = position === 1 ? 48 : 40;
    switch (position) {
      case 1:
        return <Crown weight="fill" size={size} className="text-yellow-500" />;
      case 2:
        return <Medal weight="fill" size={size} className="text-gray-300" />;
      case 3:
        return <Trophy weight="fill" size={size} className="text-amber-600" />;
      default:
        return null;
    }
  };

  return (
    <div className={`${getPositionStyles()} ${height} w-full rounded-lg flex flex-col items-center p-6 transition-all duration-300 hover:shadow-2xl`}>
      <div className="mb-2">{getMedalIcon()}</div>
      <div className="text-sm font-medium text-blue-400 mb-4">{getMedalTitle()}</div>
      
      <div className="w-24 h-24 bg-gray-700 rounded-full flex items-center justify-center mb-4 border-4 border-gray-600 shadow-inner">
        {player ? getAvatarIcon(player.avatar) : "Brak"}
      </div>
      
      <div className="text-2xl font-bold text-white mb-1">
        Miejsce {position}
      </div>
      
      <div className="text-lg font-semibold text-gray-300 mb-2 truncate w-full text-center">
        {player?.displayName || player?.username || 'Brak uczestnika'}
      </div>
      
      <div className="px-4 py-1 bg-gray-700/50 rounded-full border border-gray-600">
        <span className="text-blue-400 font-bold">
          {player?.total_points || 0} punktów
        </span>
      </div>
    </div>
  );
};

export default PodiumPosition;
